module.exports = __webpack_public_path__ + "static/media/Paradi_Privacy_Policy.98ba087c.md";